<template>
  <div class="m-skeleton" v-if="nums > 0" :style="{'z-index': zIndex || 0}">
    <div @click="fnBack" class="left" :style="{'top': `${$store.state.statusBarHeight + 10}px`}"  v-if="!+$route.query.browerFirstIn && !$route.meta.showHeader && !forceHideBackButton">
      <svg class="icon-svg" aria-hidden="true">
        <use :xlink:href="$globalIcon.backIcon"></use>
      </svg>
    </div>
    <div :style="{'background': bgColor, height: fheight}"></div>
    <div v-for="item in nums - 1 " :key="item" :style="{'background': bgColor, 'height': iheight}"></div>
  </div>
</template>
<script>
export default {
  props: ['nums', 'zIndex', 'bgColor', 'iheight', 'fheight', 'forceHideBackButton'], // forceHideBackButton 强制隐藏返回键
  methods: {
    fnBack() {
      this.$store.dispatch('doHistoryBack')
    }
  }
}
</script>
<style lang="scss">
/**
* 骨架屏
*/
.m-skeleton{
  padding: .2rem;
  padding-top: 1.84rem;
  div{
    height: 2rem;
    margin-bottom: .2rem;
    border-radius: .12rem;
    background: #fafafa;
    animation: skeleton 1.2s ease-in-out infinite;
  }
  .left {
    position: absolute;
    left: 0.28rem; //对齐单品页的返回键位置
    top: 0.14rem; //对齐单品页的返回键位置
    width: 0.64rem;
    height: 0.64rem;
    -webkit-touch-callout: none;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      width: .34rem;
      height: .34rem;
      color: #FFFFFF;
    }
  }
}

@keyframes skeleton {
  50%{
    opacity: .6;
  }
}

</style>
